import React, { useEffect, useRef, useState } from 'react';
import { Fetcher } from '../Helpers/fetcher';

// Drop this under any "Username" field on a user-creation form. It debounces
// the typed value, hits GET /api/obd/username/available/{username} (public --
// see WebSecurityConfig -- so it works on the unauthenticated free-trial
// signup page too), and shows an inline available/not-available message.
// `excludeUsername` lets an edit form pass the record's own current username
// so it doesn't get flagged as taken against itself. `onStatusChange` (optional)
// reports every status transition (null | 'checking' | 'available' | 'unavailable')
// so the parent form can hide/disable its submit button while the username is
// taken or still being checked.
const UsernameAvailability = ({ apiPath, username, excludeUsername = '', onStatusChange }) => {
    const [status, setStatus] = useState(null); // null | 'checking' | 'available' | 'unavailable'
    const timerRef = useRef(null);
    const requestIdRef = useRef(0);
    const onStatusChangeRef = useRef(onStatusChange);
    onStatusChangeRef.current = onStatusChange;

    useEffect(() => {
        if (onStatusChangeRef.current) {
            onStatusChangeRef.current(status);
        }
    }, [status]);

    useEffect(() => {
        clearTimeout(timerRef.current);
        const trimmed = (username || '').trim();

        if (!trimmed || trimmed === excludeUsername) {
            setStatus(null);
            return undefined;
        }

        const requestId = ++requestIdRef.current;
        setStatus('checking');

        timerRef.current = setTimeout(() => {
            Fetcher.get(`${apiPath}/api/obd/username/available/${encodeURIComponent(trimmed)}`)
                .then(res => {
                    if (requestId !== requestIdRef.current) return;
                    setStatus(res?.available ? 'available' : 'unavailable');
                })
                .catch(() => {
                    if (requestId !== requestIdRef.current) return;
                    setStatus(null);
                });
        }, 500);

        return () => clearTimeout(timerRef.current);
    }, [username, apiPath, excludeUsername]);

    if (!status || status === 'checking') return null;

    return (
        <div className={status === 'available' ? 'text-success' : 'text-danger'} style={{ fontSize: '0.85rem', marginTop: '4px' }}>
            '{username.trim()}' is {status === 'available' ? 'available' : 'not available'}.
        </div>
    );
};

export default UsernameAvailability;
